import { css } from '@linaria/core';

const defaultTheme = css`
  --primary-color: #fe6347;
  --secondary-color: #3f3d55;
`;

export { defaultTheme };
